// Room codes: what a host reads out and a friend types under "Join".
//
// Real words are easier to say and remember than random letters ("FROG",
// not "SRSN"). The list is picked by hand: nothing rude or grim, and no
// word that sounds like another spelling (BEAR/BARE, PEAR/PAIR, TIME/THYME)
// or hides a silent letter (LAMB, KNEE), so hearing it is enough to type
// it. Four letters, so the join box, party links and database rules (which
// want /^[A-Z]{4}$/) are unchanged. Rooms only live while someone is
// hosting, so a few hundred words is plenty; random letters are the
// fallback when every word tried is taken.

export const ROOM_WORDS = [
  'ACRE', 'ALPS', 'APEX', 'ARCH', 'ATOM', 'AXLE', 'BAKE', 'BAND', 'BARK', 'BARN', 'BASE', 'BATH',
  'BEAD', 'BEAN', 'BEEP', 'BELT', 'BEND', 'BIBS', 'BIKE', 'BIRD', 'BLOT', 'BLUR', 'BOAT', 'BOLD',
  'BOLT', 'BOOK', 'BOOM', 'BOOT', 'BOWL', 'BRAG', 'BREW', 'BRIE', 'BUGS', 'BULL', 'BUMP', 'BUNK',
  'BUSH', 'BUSY', 'BUZZ', 'CAKE', 'CALF', 'CAMP', 'CAPE', 'CARD', 'CARP', 'CART', 'CASH', 'CAVE',
  'CHAI', 'CHAT', 'CHEF', 'CHEW', 'CHIP', 'CITY', 'CLAM', 'CLAP', 'CLAW', 'CLIP', 'CLUB', 'CLUE',
  'COAT', 'COIL', 'COIN', 'COLA', 'COLT', 'CONE', 'COOL', 'COPY', 'CORK', 'CORN', 'COVE', 'COZY',
  'CRAB', 'CRIB', 'CROW', 'CUBE', 'CUBS', 'CUFF', 'CURL', 'DAMP', 'DARK', 'DART', 'DASH', 'DAWN',
  'DEAL', 'DECK', 'DEMO', 'DESK', 'DIAL', 'DICE', 'DILL', 'DIME', 'DIRT', 'DISH', 'DIVE', 'DOCK',
  'DOLL', 'DOME', 'DOOR', 'DOTS', 'DRAW', 'DRIP', 'DRUM', 'DUCK', 'DUET', 'DUNE', 'DUSK', 'DUST',
  'EASY', 'ECHO', 'EDGE', 'EGGS', 'EMUS', 'EPIC', 'FACE', 'FARM', 'FAST', 'FAWN', 'FERN', 'FETA',
  'FIGS', 'FILM', 'FIRE', 'FISH', 'FIZZ', 'FLAG', 'FLAT', 'FLEX', 'FLIP', 'FOAM', 'FOLD', 'FOLK',
  'FONT', 'FORK', 'FORT', 'FROG', 'FUEL', 'FUND', 'FUZZ', 'GAME', 'GEAR', 'GIFT', 'GLAD', 'GLEN',
  'GLOW', 'GLUE', 'GOAL', 'GOAT', 'GOLD', 'GOLF', 'GOWN', 'GRAB', 'GRID', 'GRIN', 'GULP', 'GUST',
  'HALF', 'HALO', 'HAND', 'HARP', 'HAWK', 'HELP', 'HERB', 'HERO', 'HIKE', 'HILL', 'HIVE', 'HOOK',
  'HOOP', 'HOPS', 'HORN', 'HOST', 'HUGE', 'HUSH', 'IBIS', 'IDEA', 'INCH', 'INKS', 'ITEM', 'JADE',
  'JAZZ', 'JEEP', 'JOKE', 'JUGS', 'JULY', 'JUMP', 'JUNE', 'KALE', 'KELP', 'KEYS', 'KIND', 'KING',
  'KITE', 'KIWI', 'LACE', 'LADY', 'LAKE', 'LAMP', 'LAND', 'LANE', 'LAVA', 'LAWN', 'LEAF', 'LIFT',
  'LILY', 'LIME', 'LINK', 'LION', 'LIST', 'LOAF', 'LOCK', 'LOFT', 'LOGS', 'LOON', 'LOOP', 'LOUD',
  'LUCK', 'LUMP', 'MALT', 'MAPS', 'MARK', 'MASK', 'MATH', 'MEGA', 'MELT', 'MEMO', 'MENU', 'MESA',
  'MICE', 'MILE', 'MILK', 'MIND', 'MINK', 'MINT', 'MOLE', 'MOOD', 'MOON', 'MOPS', 'MOSS', 'MOTH',
  'MUGS', 'MULE', 'NAIL', 'NAPS', 'NAVY', 'NEAT', 'NECK', 'NEST', 'NEWT', 'NICE', 'NOOK', 'NOON',
  'NOTE', 'OATS', 'OKRA', 'OPAL', 'ORCA', 'OVAL', 'OVEN', 'PACK', 'PADS', 'PAGE', 'PALS', 'PANS',
  'PARK', 'PATH', 'PEST', 'PIES', 'PINE', 'PINK', 'PIPE', 'PITA', 'PLAN', 'PLOT', 'PLUG', 'PLUM',
  'POEM', 'POET', 'POND', 'PONG', 'PONY', 'POOL', 'PORK', 'POTS', 'PROP', 'PUFF', 'PUMA', 'PUMP',
  'PUNS', 'PUPS', 'QUIZ', 'RACE', 'RAFT', 'RAKE', 'RAMP', 'REEF', 'REST', 'RIBS', 'RICE', 'RIDE',
  'RIFT', 'RIMS', 'RINK', 'RISK', 'ROBE', 'ROCK', 'ROOF', 'RUBY', 'RUST', 'SAFE', 'SAGA', 'SAGE',
  'SALT', 'SAND', 'SCAN', 'SEAL', 'SEAT', 'SHED', 'SHIP', 'SHOP', 'SILK', 'SILO', 'SKID', 'SKIP',
  'SKIS', 'SLAB', 'SLED', 'SLIM', 'SLOT', 'SLOW', 'SLUG', 'SMOG', 'SNAP', 'SNOW', 'SNUG', 'SOAP',
  'SOCK', 'SODA', 'SOFA', 'SOFT', 'SONG', 'SOUP', 'SPAN', 'SPIN', 'SPOT', 'SPUD', 'STAR', 'STEM',
  'STEP', 'STEW', 'SUIT', 'SWAN', 'SWAP', 'SWAY', 'SWIM', 'TACO', 'TALK', 'TALL', 'TAME', 'TANK',
  'TAPE', 'TAPS', 'TART', 'TAXI', 'TEAL', 'TENT', 'TEXT', 'THUD', 'TICK', 'TILE', 'TINY', 'TOFU',
  'TOOL', 'TOPS', 'TOSS', 'TOTS', 'TOWN', 'TOYS', 'TRAM', 'TRAY', 'TREE', 'TREK', 'TRIM', 'TRIO',
  'TRIP', 'TROT', 'TUBA', 'TUBE', 'TUFT', 'TUNA', 'TUNE', 'TUSK', 'TWIG', 'TWIN', 'UNDO', 'UNIT',
  'VASE', 'VAST', 'VERB', 'VEST', 'VIEW', 'VINE', 'VOLT', 'VOTE', 'WAGE', 'WALK', 'WALL', 'WAND',
  'WARM', 'WARP', 'WASP', 'WAVE', 'WAVY', 'WEBS', 'WELL', 'WEST', 'WHIP', 'WICK', 'WIDE', 'WIGS',
  'WILD', 'WILT', 'WING', 'WINK', 'WIPE', 'WIRE', 'WISH', 'WOLF', 'WORD', 'WORM', 'YAKS', 'YARD',
  'YARN', 'YAWN', 'YELL', 'YELP', 'YOYO', 'ZANY', 'ZERO', 'ZEST', 'ZINC', 'ZIPS', 'ZONE', 'ZOOM',
];

// No I or O: they read as 1 and 0 when someone says the code out loud.
const CODE_LETTERS = 'ABCDEFGHJKLMNPQRSTUVWXYZ';

const pick = (list) => list[Math.floor(Math.random() * list.length)];

export function randomWord() {
  return pick(ROOM_WORDS);
}

export function randomLetters() {
  let code = '';
  for (let i = 0; i < 4; i += 1) code += pick(CODE_LETTERS);
  return code;
}

export function cleanCode(text) {
  return String(text || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 4);
}
